import { render, staticRenderFns } from "./LaboratoriesDetails.vue?vue&type=template&id=16e606a8"
import script from "./LaboratoriesDetails.vue?vue&type=script&lang=js"
export * from "./LaboratoriesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports